import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../../../infrastructure/handlers/populate-data-handler";
import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";

export class EntityMegaHeaderModuleHandlers extends HandlerList {
  static injectables = [TimingHandler, PopulateDataHandler];

  constructor(
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
